<template>
  <div class="register">
    <ValidationObserver class="register-form" tag="div" ref="form">
      <form @submit.prevent="onSubmit" class="form">
        <ValidationProvider class="form-item" tag="div" name="username" rules="username" v-slot="{ errors }">
          <div class="input-field">
            <span class="form-icon username"></span>
            <input class="form-input" type="text" v-model="params.username" placeholder="Tên đăng nhập" />
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <ValidationProvider class="form-item" tag="div" name="password" rules="password" v-slot="{ errors }">
          <div class="input-field">
            <span class="form-icon password"></span>
            <input
              class="form-input"
              :type="hidePassword ? 'password' : 'text'"
              v-model="params.password"
              placeholder="Mật khẩu"
            />
            <span :class="`hide-input ${hidePassword ? 'off' : 'on'}`" @click="hidePass"></span>
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <ValidationProvider
          class="form-item"
          tag="div"
          name="confirmPassword"
          rules="password|confirmPassword"
          v-slot="{ errors }"
        >
          <div class="input-field">
            <span class="form-icon password"></span>
            <input
              class="form-input"
              :type="hideConfirmPassword ? 'password' : 'text'"
              v-model="params.confirmPassword"
              placeholder="Nhập lại mật khẩu"
            />
            <span :class="`hide-input ${hideConfirmPassword ? 'off' : 'on'}`" @click="hideConPass"></span>
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <ValidationProvider class="form-item" tag="div" name="captcha" rules="captcha" v-slot="{ errors }">
          <div class="input-field">
            <span class="form-icon captcha"></span>
            <input class="form-input" type="text" v-model="params.captcha" placeholder="Mã xác minh" />
            <span class="captcha_box" @click.stop="changeCaptcha">
              <img :src="captchaSrc" alt />
            </span>
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <div class="submit-register">
          <button class="btn-submit register" type="submit">
            <img class="icon-bonus" src="../assets/image/reg_btn.png" alt="" />
          </button>
        </div>
      </form>
    </ValidationObserver>
    <UserInfo v-if="show" @toLogin="toLogin" :info="params" />
  </div>
</template>

<script>
import { extend } from "vee-validate";
import Api from "../api/api";
import { isMobile } from "../utils/utils";
import UserInfo from "./userInfo";
export default {
  data() {
    return {
      params: {
        username: "",
        password: "",
        confirmPassword: "",
        captcha: "",
      },
      captchaSrc: "",
      hidePassword: true,
      hideConfirmPassword: true,
      show: false,
    };
  },
  components: { UserInfo },
  mounted() {
    extend("confirmPassword", {
      validate: (value) => {
        return this.params.password === this.params.confirmPassword;
      },
      computesRequired: true,
      message: "Nhập lại mật khẩu không đúng",
    });
    this.changeCaptcha();
  },
  computed: {
    domainUrl() {
      return this.$store.state.domain;
    },
  },
  methods: {
    hidePass() {
      this.hidePassword = !this.hidePassword;
    },
    hideConPass() {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    },
    toLogin() {
      this.show = false;
      if (!this.domainUrl) {
        return;
      }
      let url = "";
      isMobile() ? (url = "m/login") : (url = "index");
      if (this.domainUrl.endsWith("/")) {
        location.href = `${this.domainUrl}${url}`;
      } else {
        location.href = `${this.domainUrl}/${url}`;
      }
    },
    async onSubmit() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.$loading.show();
        Api.register({ data: this.params })
          .then((res) => {
            if (res.success) {
              this.show = true;
            }
          })
          .finally(() => this.$loading.hide());
      }
    },
    changeCaptcha() {
      Api.getCaptcha().then((res) => {
        if (res.value) {
          this.captchaSrc = "data:image/png;base64," + res.value;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.register {
  width: 100%;
  .register-form {
    width: 100%;
  }
  .form {
    width: 100%;
  }
  .submit-register {
    width: 100%;
    position: absolute;
    left: 50%;
    bottom: 5px;
    padding: 0 43px;
    transform: translateX(-50%);
  }
  .btn-submit.register {
    position: relative;
    background-color: transparent !important;
    .icon-bonus {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
  .captcha_box {
    width: 100px;
    height: 52px;
    border-radius: 26px;
    overflow: hidden;
    border: 3px solid #000;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.usr_info {
  width: 100px;
  height: 500px;
  background: #000;
}
</style>
